export const SOCIALS = [
  { name: "Legend Magazine", handle: "@legendmagazine.it", url: "https://www.instagram.com/legendmagazine.it/", platform: "instagram" },
  { name: "Legend Team ASD", handle: "@legendteam_asd", url: "https://www.instagram.com/legendteam_asd/", platform: "instagram" },
  { name: "Legend Team ASD", handle: "@LegendTeamASD", url: "https://www.youtube.com/@LegendTeamASD", platform: "youtube" },
  { name: "Facebook", handle: "In costruzione", url: "#", platform: "facebook", soon: true },
];

// Sponsor logos with a baked-in black background — shown on a black tile (no grey frame) so they stay readable.
export const isDarkLogo = (name = "") => /simoni|essex|kemipol|levii/i.test(name);
export const logoCardCls = (name) =>
  isDarkLogo(name) ? "bg-black border border-black" : "bg-white border border-slate-200 dark:border-slate-700";

// Radio LiveGP — Spreaker web radio (motorsport). Click-to-play floating player.
export const RADIO_LIVEGP_SHOW = "1466029";
export const RADIO_LIVEGP_SITE = "https://www.livegp.it/";

// Event posters archive (F1/rally-style list) — thumbnails open the downloadable PDF.
export const LOCANDINE = [
  { slug: "sogliano-2026", title: "Coppa Romagna Slalom — Sogliano al Rubicone", location: "Sogliano al Rubicone (FC)", date: "2026-10-18", date_label: "18 Ottobre 2026", category: "Slalom", thumb: "/locandine/sogliano-2026.jpg", pdf: "/locandine/sogliano-2026.pdf", current: true },
];

// Editable YouTube embeds. Fallback link always points to the official channel.
export const VIDEOS = [
  { id: "5mxAn0S0rgk", title: "Rally della Romagna — Azione e onboard sulle prove speciali" },
  { id: "MWeCxRhAX-s", title: "Shakedown — Azione e adrenalina sulle prove speciali" },
];
export const YT_CHANNEL = "https://www.youtube.com/@LegendTeamASD";

export const LEGENDTEAM_URL = "https://legendteam.it";
export const LEGENDTEAM_LOGO = "/legend/legend-team-logo.png";
export const LEGENDTEAM_BANNER = "/legend/legend-team-banner.jpg";

// Tesseramento 2026 — Settore Motori MSP Italia (costi per correre con il Legend Team)
export const TESSERAMENTO = {
  societa: [
    { name: "Base", price: 10, note: "Adesione / Sostenitore" },
    { name: "Tecnico", price: 20, note: "Ruoli Tecnico-Sportivi" },
  ],
  auto: [
    { name: "Promo Classica", price: 35, note: "Automobilismo · Abilità" },
    { name: "Promo Kart", price: 35, note: "Automobilismo · Karting" },
    { name: "Sportiva Kart", price: 80, note: "Karting · Agonistica A1" },
    { name: "Sportiva Fuoristrada", price: 80, note: "Fuoristrada · Agonistica A1" },
    { name: "Sportiva Territoriale", price: 80, note: "Abilità · Agonistica A1" },
    { name: "Sportiva Nazionale", price: 100, note: "Abilità · Agonistica A1" },
  ],
  moto: [
    { name: "Promo EN / MX / SM-FT / QD / VT", price: 35, note: "Motociclismo · Non agonistica" },
    { name: "Sportiva EN / MX / SM-FT / QD", price: 80, note: "Motociclismo · Agonistica" },
    { name: "Sport Velocità (VT)", price: 80, note: "Motociclismo · Agonistica" },
  ],
  note: "Quote comprensive di affiliazione, adesione al Settore Motori e coperture assicurative abbinate (Polizza Tesseramento MSP Italia + coperture ASD SportItalia). Estensione validità da Territoriale a Nazionale: +25 €. Tessera elettronica in PDF, personale e incedibile.",
};
export const CONTACT_EMAIL = "info@legendmagazine.it";

export const SPONSOR_GRID = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/1lkput9e_image.png";
export const MPH_INSTAGRAM = "https://www.instagram.com/mph.team_asd/";
export const RPM_INSTAGRAM = "https://www.instagram.com/rpm.events/";
export const RPM_LOGO = "/sponsors/rpm.png";
export const MPH_LOGO = "/sponsors/mph.png";
export const PARTNERS = [
  { name: "MPH Team ASD", logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/ydiasril_image.png", url: "https://www.instagram.com/mph.team_asd/", tagline: "Partner Legend Team" },
  { name: "RPM Events", logo: "/sponsors/rpm.png", url: "https://www.instagram.com/rpm.events/", tagline: "Eventi & Racing" },
  { name: "Endrift Garage", logo: "/sponsors/endrift-garage.png", url: "https://www.instagram.com/endrift_garage/", tagline: "Drift Team · ospite alla Coppa Romagna Slalom di Sogliano con il Legend Team", role: "Team Drift" },
  { name: "Alessandro Bellucci Photography", logo: "/sponsors/ab-photography.png", url: "https://www.instagram.com/ab_.photography.__/", tagline: "Photography & Videography 🇮🇹 · capturing emotions · Motorsport | Event | Video", role: "Media Partner" },
];
export const NIGHT_FESTA = "/festa-sogliano.jpg";
export const BASTOS_CAR = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/g66ty0tu_photo_2026-09-26_18-50-38.jpg";
export const PEUGEOT_106 = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/rh43t3ai_DSC_1530.webp";
export const WHATSAPP_URL = "https://wa.me/393791222217?text=Ciao%20Legend%20Team%2C%20vorrei%20un%27informazione";
export const WHATSAPP_NUMBER = "3791222217";
export const LOGO_URL = "/legend-logo.png";

// Individual sponsor logos (cropped from the official grid) — shown on every page.
export const SPONSORS = [
  { name: "Kemipol", logo: "/sponsors/kemipol.png", url: "https://kemipolsrl.it" },
  { name: "MCG S.r.l. — Mulinari Costruzioni", logo: "/sponsors/mcg-v2.png", url: "https://mulinaricostruzioni.it" },
  { name: "Merlin Solution", logo: "/sponsors/merlin.png", url: "https://merlinsolution.eu" },
  { name: "Netso S.p.A.", logo: "/sponsors/netso.png", url: "https://netso.it" },
  { name: "Simoni Racing", logo: "/sponsors/simoniracing.png", url: "https://simoniracing.com" },
  { name: "Essex Racing Oils & Fuels", logo: "/sponsors/essex.png", url: "https://essexlubra.com" },
  { name: "Levii Trentodoc", logo: "/sponsors/levii.png", url: "https://levii.it" },
  { name: "La Pieda", logo: "/sponsors/lapieda.png", url: "https://www.facebook.com/Ristorantelapieda/?locale=it_IT" },
  { name: "Thinnk", logo: "/sponsors/thinnk.png", url: "http://www.thinnk.it" },
  { name: "Medius S.r.l. Edilizia", logo: "/sponsors/medius.png", url: "https://atoka.io/public/it/azienda/medius-srl/c8059f39c8d7" },
  { name: "Pandora Consulting", logo: "/sponsors/pandora-consulting.png", url: "https://pandora-consulting.it" },
  { name: "Sassa Motor & Sport", logo: "/sponsors/sassa-motorsport.png", url: "https://www.sassamotorsport.com" },
  { name: "Telefonia Vilar", logo: "/sponsors/telefonia-vilar.jpg", url: "https://www.facebook.com/vilar.telefonia/" },
  { name: "AGM Automazioni", logo: "/sponsors/agm-automazioni.jpg", url: "https://www.agmautomazioni.it" },
];

// Rally mechanics page — curated YouTube videos on how a rally car is built and how it works.
export const MECCANICA_VIDEOS = [
  { id: "eq5EZ_FOfTk", title: "Come nasce un'auto da rally: il build time-lapse di una Subaru WRX", note: "18 mesi di lavoro condensati: dal telaio nudo alla vettura pronta per le prove speciali (Vermont SportsCar)." },
  { id: "h6yfhKhCp-s", title: "Da auto stradale a vettura da rally: la trasformazione in garage", note: "La conversione di una Subaru Impreza GC8 in un'auto da rally, gabbia di sicurezza compresa." },
  { id: "1H4jxhZdWYo", title: "Come funziona un'auto WRC: motore, trazione e aerodinamica", note: "1.6 turbo da 380 cavalli, 0-100 in meno di 3,5 secondi su qualsiasi fondo: la tecnica spiegata." },
  { id: "earjqfXGYzw", title: "I pace notes: come il navigatore 'legge' la strada al pilota", note: "Il sistema di note che permette al pilota di affrontare le curve alla cieca in piena fiducia." },
  { id: "PgZLjM7zyXo", title: "Onboard: la sincronia tra pilota e navigatore", note: "Un giro onboard per capire il ritmo e la coordinazione dell'equipaggio sulle prove speciali." },
];

// Locandina / evento assets
export const PLATE_SOGLIANO = "https://static.prod-images.emergentagent.com/jobs/ca8f8217-9489-499e-8c90-080ff03cc398/images/0bbafd8a7501259e0572bd69f610bd4398d4ba76459959220b6efe10c52a33fc.jpeg";
export const SOGLIANO_HERO = "https://static.prod-images.emergentagent.com/jobs/ca8f8217-9489-499e-8c90-080ff03cc398/images/4aa8a8e13c5fa61225ab4b29a9a6d02ee8b14556e2c57c779c9c16f969a56d0a.jpeg";
export const MSP_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/h3lfsmgw_image.png";
export const AUTOMOTOSPORT_LOGO = "/sponsors/automotosport.png";
export const COMUNE_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/tv08chqt_image.png";
export const COPPA_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_rally-magazine/artifacts/bnulfv2u_image.png";

export const LEGAL_FULL = `Legend Magazine — Testata giornalistica registrata presso il Pubblico Registro della Stampa del Tribunale di Rimini al N. 5 del Registro Stampa, in data 02/09/2026 (Num. R.G. 1461/2026). Editore e Proprietario: Legend Team S.r.l. Sportiva Dilettantistica (Strada Perticara 13, 47866 Sant'Agata Feltria - RN | P.IVA/C.F. 03858691201). Direttore Responsabile: Simone Massaccesi. Periodicità: Mensile / Rete Internet — Luogo di pubblicazione e redazione: Sant'Agata Feltria (RN).`;

export const NAV = [
  { label: "Home", en: "Home", to: "/" },
  { label: "Rally & Gare", en: "Rally & Races", to: "/?cat=Rally%20%26%20Gare" },
  { label: "Interviste", en: "Interviews", to: "/?cat=Interviste" },
  { label: "Tecnica & Tuning", en: "Tech & Tuning", to: "/?cat=Tecnica%20%26%20Tuning" },
  { label: "Legend Team", en: "Legend Team", to: "/legend-team" },
  { label: "Calendario", en: "Calendar", to: "/calendario" },
  { label: "Meccanica Rally", en: "Rally Tech", to: "/meccanica" },
  { label: "Scarica l'App", en: "Get the App", to: "/app" },
  { label: "Grazie Pubblicità", en: "Advertising", to: "/grazie-sponsor" },
  { label: "Locandina", en: "Event Poster", to: "/locandina" },
  { label: "Abbonamenti", en: "Subscriptions", to: "/abbonamenti" },
];
